import { Component } from '@angular/core';

import { InsightsCardComponent, InsightsComponent } from '@core/impact-tracker-ui';
import { ButtonComponent, DialogComponentI, IconName } from '@core/user-interface-legacy';

export type InsightsCardData = {
  icon: IconName;
  value: string;
  title: string;
  label: string;
  tooltip: string;
};

export type InsightDialogData = {
  heading: string;
  logoHeading: string;
  subheading: string;
  cards: InsightsCardData[];
};

@Component({
  selector: 'rt-insights-dialog',
  imports: [InsightsComponent, InsightsCardComponent, ButtonComponent],
  templateUrl: './insights-dialog.component.html',
  styleUrl: './insights-dialog.component.less',
})
export class InsightsDialogComponent implements DialogComponentI<InsightDialogData, any> {
  protected data: InsightDialogData;

  public setDialogData(data: InsightDialogData, triggerUpdate: boolean): void {
    this.data = data;
  }
}
